/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Empty_SocialInputs */

const cs_templates_empty_social = /** @type {(inputs: Templates_Empty_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné šablony pro sociální sítě.`)
};

const en_templates_empty_social = /** @type {(inputs: Templates_Empty_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No social post templates yet.`)
};

/**
* | output |
* | --- |
* | "No social post templates yet." |
*
* @param {Templates_Empty_SocialInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_empty_social = /** @type {((inputs?: Templates_Empty_SocialInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Empty_SocialInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_empty_social(inputs)
	return cs_templates_empty_social(inputs)
});